<template>
  <div class="content">
    <div class="md-layout">
      <md-app md-mode="reveal">
        <md-app-toolbar class="md-primary">
          <md-button
            class="md-icon-button md-primary"
            @click="menuVisible = !menuVisible"
          >
            <md-icon>menu</md-icon>
          </md-button>
          <span class="md-title" v-if="selectedInspection"
            >{{ $t("details.title") }} ID {{ selectedInspection.tag }}</span
          >
        </md-app-toolbar>

        <md-app-drawer :md-active.sync="menuVisible">
          <md-toolbar class="md-transparent" md-elevation="0">{{
            $t("details.selected")
          }}</md-toolbar>

          <md-list>
            <md-list-item
              v-for="inspection in details_page.selected_inspections"
              @click="change_selected_inspection(inspection.id)"
              v-bind:key="inspection.tag"
            >
              <span class="md-list-item-text">ID {{ inspection.tag }}</span>
            </md-list-item>
          </md-list>
        </md-app-drawer>

        <md-app-content>
          <div class="md-layout" v-if="dataLoading">
            <div
              class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
            >
              <md-progress-spinner
                md-mode="indeterminate"
              ></md-progress-spinner>
            </div>
          </div>
          <div class="md-layout" v-if="!dataLoading">
            <div
              class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-30"
            >
              <div class="md-layout">
                <div class="md-card md-theme-default">
                  <div class="md-card-header">
                    <span class="custom-span">
                      <h4 class="title">Info</h4>
                    </span>
                  </div>
                  <div
                    class="md-content md-table-content md-scrollbar md-theme-default"
                    style="margin-top:0px; background-color: rgba(0,0,0,0.0)"
                  >
                    <md-table v-if="selectedInspection">
                      <md-table-row
                        v-if="selectedInspection.address !== 'null'"
                      >
                        <md-table-cell>{{
                          $t("details.info.location")
                        }}</md-table-cell>
                        <md-table-cell>
                          <pre
                            style="font-family: Nunito, sans-serif; text-align: left;"
                            >{{ selectedInspection.address }}</pre
                          >
                        </md-table-cell>
                      </md-table-row>

                      <md-table-row>
                        <md-table-cell>{{
                          $t("details.info.material")
                        }}</md-table-cell>
                        <md-table-cell>{{
                          selectedInspection.material
                        }}</md-table-cell>
                      </md-table-row>

                      <md-table-row>
                        <md-table-cell>{{
                          $t("details.info.construction_year")
                        }}</md-table-cell>
                        <md-table-cell>{{
                          selectedInspection.constructionyear
                        }}</md-table-cell>
                      </md-table-row>

                      <md-table-row>
                        <md-table-cell
                          >Diameter ({{ length1.view }})</md-table-cell
                        >
                        <md-table-cell>{{
                          convert(parseFloat(selectedInspection.diameter))
                            .from(length1.save)
                            .to(length1.view)
                            .toFixed(3)
                        }}</md-table-cell>
                      </md-table-row>

                      <md-table-row>
                        <md-table-cell
                          >{{ $t("details.info.exp_wt") }} ({{
                            length1.view
                          }})</md-table-cell
                        >
                        <md-table-cell>{{
                          convert(
                            parseFloat(
                              selectedInspection.wallthickness_expected
                            )
                          )
                            .from(length1.save)
                            .to(length1.view)
                            .toFixed(3)
                        }}</md-table-cell>
                      </md-table-row>

                      <md-table-row>
                        <md-table-cell
                          >{{ $t("details.info.val_wt") }} ({{
                            length1.view
                          }})</md-table-cell
                        >
                        <md-table-cell>{{
                          convert(
                            parseFloat(
                              selectedInspection.wallthickness_expected_validation
                            )
                          )
                            .from(length1.save)
                            .to(length1.view)
                            .toFixed(3)
                        }}</md-table-cell>
                      </md-table-row>

                      <md-table-row>
                        <md-table-cell
                          >{{ $t("details.info.circumference") }} ({{
                            length1.view
                          }})</md-table-cell
                        >
                        <md-table-cell>{{
                          convert(parseFloat(selectedInspection.circumference))
                            .from(length1.save)
                            .to(length1.view)
                            .toFixed(3)
                        }}</md-table-cell>
                      </md-table-row>

                      <md-table-row v-if="$i18n.locale == 'nl'">
                        <md-table-cell>RD X</md-table-cell>
                        <md-table-cell>{{
                          selectedInspection.RDX
                        }}</md-table-cell>
                      </md-table-row>

                      <md-table-row v-if="$i18n.locale == 'nl'">
                        <md-table-cell>RD Y</md-table-cell>
                        <md-table-cell>{{
                          selectedInspection.RDY
                        }}</md-table-cell>
                      </md-table-row>

                      <md-table-row v-if="$i18n.locale == 'en'">
                        <md-table-cell>WGS-84 Latitude</md-table-cell>
                        <md-table-cell>{{
                          selectedInspection.latitude
                        }}</md-table-cell>
                      </md-table-row>

                      <md-table-row v-if="$i18n.locale == 'en'">
                        <md-table-cell>WGS-84 Longitude</md-table-cell>
                        <md-table-cell>{{
                          selectedInspection.longitude
                        }}</md-table-cell>
                      </md-table-row>

                      <md-table-row v-if="selectedInspection.client_ref">
                        <md-table-cell>Project/Dossier nummer</md-table-cell>
                        <md-table-cell>{{
                          selectedInspection.client_ref
                        }}</md-table-cell>
                      </md-table-row>
                      <!--
                    <md-table-row>
                      <md-table-cell>Coverage (m)</md-table-cell>
                      <md-table-cell>{{ showInspection.z }}</md-table-cell>
                    </md-table-row>-->
                    </md-table>
                  </div>
                </div>
              </div>
              <div class="md-layout">
                <div class="md-card md-theme-default">
                  <div class="md-card-header">
                    <h4 class="title">{{ $t("images.images") }}</h4>
                  </div>
                  <div
                    class="md-card-content"
                    style="width:100%; padding-top:15px; padding-left: 0; padding-bottom:0; padding-right: 0"
                  >
                    <lingallery
                      :iid.sync="currentId"
                      :responsive="responsive"
                      :items="images"
                      :showThumbnails="showThumbnails"
                      v-if="images.length > 0"
                    />

                    <div class="alert alert-info" v-if="images.length == 0">
                      <span><b> Info - </b> {{ $t("images.nan") }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-70"
            >
              <div class="md-card md-theme-default">
                <div class="md-card-header">
                  <span class="custom-span">
                    <h4 class="title">{{ $t("details.insights.title") }}</h4>
                  </span>
                </div>
                <div
                  class="md-content md-table-content md-scrollbar md-theme-default"
                  style="margin-top:0px; background-color: rgba(0,0,0,0.0)"
                >
                  <md-tabs class="md-primary" md-alignment="right">
                    <md-tab
                      id="tab-boxplots"
                      md-icon="assessment"
                      :md-label="$t('details.insights.stats')"
                    >
                      <div v-if="!dataLoading">
                        <Plotly
                          :data="boxplotlyData"
                          :layout="boxplotlyLayout"
                          :display-mode-bar="false"
                        ></Plotly>
                      </div>
                    </md-tab>

                    <md-tab
                      id="tab-wtplots"
                      md-icon="scatter_plot"
                      :md-label="$t('details.insights.wt_plot')"
                    >
                      <div style="padding:15px 20px">
                        <md-field v-if="selectedInspection">
                          <label for="measurement">{{
                            $t("details.insights.select")
                          }}</label>
                          <md-select
                            v-model="selectedMeasurement"
                            name="measurement"
                            id="measurement"
                            ref="test"
                          >
                            <md-option
                              v-for="ent in Object.keys(
                                selectedInspection.results
                              )"
                              :value="ent"
                              v-bind:key="ent"
                              >{{ ent }}</md-option
                            >
                          </md-select>
                        </md-field>
                      </div>

                      <div v-if="lineplotlyData && selectedInspection">
                        <Plotly
                          :data="[
                            ...lineplotlyData[selectedMeasurement],
                            ...localSpots,
                          ]"
                          :layout="lineplotlyLayout"
                          :display-mode-bar="true"
                        ></Plotly>

                        <Plotly
                          :data="polarplotlyData[selectedMeasurement]"
                          :layout="polarplotlyLayout"
                          :display-mode-bar="true"
                          v-if="
                            selectedInspection.results[selectedMeasurement]
                              .type == 'circumferential'
                          "
                        ></Plotly>
                      </div>
                      <div style="padding:15px 20px">
                        <div class="md-layout md-gutter md-size-100">
                          <div class="md-layout-item md-size-100">
                            <h4>{{ $t("details.spots.localSpots") }}</h4>
                          </div>
                          <div class="md-layout-item md-size-50">
                            <label>{{ $t("details.spots.minRelDepth") }}</label>
                            <vue-slider
                              :min="0"
                              :max="100"
                              v-model="localSpotsRelativeDepth"
                            />
                          </div>
                          <div class="md-layout-item md-size-50">
                            <label>{{ $t("details.spots.minWidth") }}</label>
                            <vue-slider
                              :min="0"
                              :max="100"
                              v-model="localSpotsWidthMin"
                            />
                          </div>
                        </div>
                      </div>
                      <div style="padding:15px 20px">
                        <md-table v-model="tableSpots">
                          <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                          >
                            <md-table-cell
                              :md-label="
                                $t('details.spots.depth') +
                                  ' (' +
                                  length1.view +
                                  ')'
                              "
                              md-sort-by="depthToThreshold"
                              >{{
                                convert(item.depthToThreshold)
                                  .from(length1.save)
                                  .to(length1.view)
                                  .toFixed(2)
                              }}</md-table-cell
                            >
                            <md-table-cell
                              :md-label="
                                $t('details.spots.width') +
                                  ' (' +
                                  length1.view +
                                  ')'
                              "
                              md-sort-by="width"
                              >{{
                                convert(item.width)
                                  .from(length1.save)
                                  .to(length1.view)
                                  .toFixed(2)
                              }}</md-table-cell
                            >
                          </md-table-row>
                        </md-table>
                      </div>
                    </md-tab>
                  </md-tabs>
                </div>
              </div>
            </div>
          </div>
        </md-app-content>
      </md-app>
    </div>
  </div>
</template>
<style lang="css">
.md-tabs-content table thead {
  display: table-header-group !important;
}
</style>

<script>
import { mapState, mapMutations } from "vuex";
import { MglMap, MglMarker, MglPopup, MglVectorLayer } from "vue-mapbox";
import axios from "axios";
import qs from "querystring";
import jwt_decode from "jwt-decode";
import { Plotly } from "vue-plotly";
import Lingallery from "lingallery";
import LocalDegradationSpots from "@/localdegradation/localdegradation.js";
import VueSlider from "vue-slider-component";
import convert from "convert-units";
export default {
  components: {
    Plotly,
    VueSlider,
    Lingallery,
  },
  data() {
    return {
      accessToken:
        "pk.eyJ1Ijoid2VybmVyYWNxIiwiYSI6ImNqeTc1d3VrajAxazUzb255NmM5cjhuMTYifQ.Z8ZqYDJDMAuGKKCHdehiSQ", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/mapbox/streets-v11", // your map style
      centerCoordinates: [5.2915073, 51.6881809],

      inspection: {
        id: "ID41",
      },
      tableSpots: [],
      dataLoading: true,
      localSpotsRelativeDepth: 10.0,
      localSpots: [],
      showInspection: null,
      menuVisible: false,
      measurements: null,
      viewTag: null,
      boxplotData: null,
      boxplotLabels: [],
      boxplotChartData: null,
      lineplotData: null,
      lineplotChartData: null,
      lineplotOrg: null,
      lineplotLabels: [],
      detailView: "boxplot",
      selectedMeasurement: 0,
      readyToView: false,
      boxplotlyData: [],
      boxplotlyLayout: {
        yaxis: {
          title: "Thickness ",
        },
      },
      localSpotsWidthMin: 15,
      lineplotlyData: null,
      lineplotlyLayout: {
        //title: "Wall Thickness",
        xaxis: {
          title: "Distance (mm)",
          //showgrid: true,
          showline: true,
          zeroline: false,
        },
        yaxis: {
          title: "Thickness (mm)",
          showline: true,

          zeroline: false,
        },
      },
      lineplotObj: {},
      polarplotlyData: null,
      polarplotlyLayout: {
        polar: {
          angularaxis: {
            rotation: 90,
            direction: "counterclockwise",
          },
        },
      },
      viewCirc: false,
      images: [],
      imagesLoading: true,
      currentId: null,
      width: 600,
      height: 400,
      showThumbnails: false,
      responsive: true,
      selectedInspection: null,
      inspectionData: [],
    };
  },
  computed: {
    ...mapState([
      "groupServices",
      "details_page",
      "apiEndpoints",
      "groupSelected",
      "units",
      "unitsDescription",
    ]),
    /**
     * computed property for unit conversion between mm and in
     * @return {obj} object with both view and save units
     */
    length1() {
      return {
        view: this.unitsDescription[this.units].length,
        save: this.unitsDescription.metric.length,
        metric: this.unitsDescription.metric.length,
        imperial: this.unitsDescription.imperial.length,
      };
    },
    /**
     * computed property for unit conversion between m and ft
     * @return {obj} object with both view and save units
     */
    length2() {
      return {
        view: this.unitsDescription[this.units].length2,
        save: this.unitsDescription.metric.length2,
        metric: this.unitsDescription.metric.length2,
        imperial: this.unitsDescription.imperial.length2,
      };
    },
  },
  watch: {
    /**
     * watcher to check the validity of route compared to services of group
     * @param {Array} newVal - New value of group services
     */
    groupServices(newVal) {
      if (!newVal.includes("pipescanner-inspections")) {
        this.$router.push("/");
      }
    },
    /**
     * watcher for change in units
     * @param {str} unitsVal - New value of units
     */
    units: function(unitsVal) {
      var val = this.selectedInspection;
      this.boxplotlyData = Object.keys(val.results).map((x) => {
        return {
          y: val.results[x].wt_remaining.map((g) =>
            convert(g)
              .from(this.length1.save)
              .to(this.length1.view)
          ),
          name: "Serie: " + String(x),
          type: "box",
        };
      });
      let labels = Object.keys(val.results);
      this.selectedMeasurement = labels[0];

      let lineplotData = {};
      let polarplotData = {};
      Object.keys(val.results).forEach((ent) => {
        lineplotData[ent] = [
          {
            x: val.results[ent].dist.map((g) =>
              convert(g)
                .from(this.length1.save)
                .to(this.length1.view)
            ),
            y: val.results[ent].wt_remaining.map((g) =>
              convert(g)
                .from(this.length1.save)
                .to(this.length1.view)
            ),
            mode: "markers",
            name: this.$t("details.graphs.mesWT"),
            type: "scatter",
          },
          {
            x: val.results[ent].dist.map((g) =>
              convert(g)
                .from(this.length1.save)
                .to(this.length1.view)
            ),
            y: val.results[ent].wt_remaining
              .map(
                (x) => this.selectedInspection.wallthickness_expected_validation
              )
              .map((g) =>
                convert(g)
                  .from(this.length1.save)
                  .to(this.length1.view)
              ),
            mode: "markers",
            name: this.$t("details.graphs.orgWT"),
            type: "scatter",
          },
        ];
        polarplotData[ent] = [
          {
            theta: val.results[ent].roll.map((x) => (x * 180.0) / Math.PI),
            r: val.results[ent].wt_remaining.map((g) =>
              convert(g)
                .from(this.length1.save)
                .to(this.length1.view)
            ),
            mode: "markers",
            name: this.$t("details.graphs.mesWT"),
            type: "scatterpolar",
          },
          {
            theta: val.results[ent].roll.map((x) => (x * 180.0) / Math.PI),
            r: val.results[ent].wt_remaining
              .map(
                (x) => this.selectedInspection.wallthickness_expected_validation
              )
              .map((g) =>
                convert(g)
                  .from(this.length1.save)
                  .to(this.length1.view)
              ),
            mode: "markers",
            name: this.$t("details.graphs.orgWT"),
            type: "scatterpolar",
          },
        ];
      });

      this.lineplotlyData = lineplotData;
      this.polarplotlyData = polarplotData;
      this.boxplotlyLayout.yaxis.title =
        this.$t("details.graphs.thickness") + "(" + this.length1.view + ")";
      this.lineplotlyLayout.xaxis.title =
        this.$t("details.graphs.distance") + "(" + this.length1.view + ")";
      this.lineplotlyLayout.yaxis.title =
        this.$t("details.graphs.thickness") + "(" + this.length1.view + ")";
      this.calculate_local_spots(this.selectedMeasurement);
    },
    /**
     * watcher to handle change in inspection selected (showing results for newly selected)
     * @param {obj} val - the selected inspection
     */
    selectedInspection: function(val) {
      this.get_images();
      this.boxplotlyData = Object.keys(val.results).map((x) => {
        return {
          y: val.results[x].wt_remaining.map((g) =>
            convert(g)
              .from(this.length1.save)
              .to(this.length1.view)
          ),
          name: "Serie: " + String(x),
          type: "box",
        };
      });
      let labels = Object.keys(val.results);
      this.selectedMeasurement = labels[0];

      let lineplotData = {};
      let polarplotData = {};
      Object.keys(val.results).forEach((ent) => {
        lineplotData[ent] = [
          {
            x: val.results[ent].dist.map((g) =>
              convert(g)
                .from(this.length1.save)
                .to(this.length1.view)
            ),
            y: val.results[ent].wt_remaining.map((g) =>
              convert(g)
                .from(this.length1.save)
                .to(this.length1.view)
            ),
            mode: "markers",
            name: this.$t("details.graphs.mesWT"),
            type: "scatter",
          },
          {
            x: val.results[ent].dist.map((g) =>
              convert(g)
                .from(this.length1.save)
                .to(this.length1.view)
            ),
            y: val.results[ent].wt_remaining
              .map(
                (x) => this.selectedInspection.wallthickness_expected_validation
              )
              .map((g) =>
                convert(g)
                  .from(this.length1.save)
                  .to(this.length1.view)
              ),
            mode: "markers",
            name: this.$t("details.graphs.orgWT"),
            type: "scatter",
          },
        ];
        polarplotData[ent] = [
          {
            theta: val.results[ent].roll.map((x) => (x * 180.0) / Math.PI),
            r: val.results[ent].wt_remaining.map((g) =>
              convert(g)
                .from(this.length1.save)
                .to(this.length1.view)
            ),
            mode: "markers",
            name: this.$t("details.graphs.mesWT"),
            type: "scatterpolar",
          },
          {
            theta: val.results[ent].roll.map((x) => (x * 180.0) / Math.PI),
            r: val.results[ent].wt_remaining
              .map(
                (x) => this.selectedInspection.wallthickness_expected_validation
              )
              .map((g) =>
                convert(g)
                  .from(this.length1.save)
                  .to(this.length1.view)
              ),
            mode: "markers",
            name: this.$t("details.graphs.orgWT"),
            type: "scatterpolar",
          },
        ];
      });

      this.lineplotlyData = lineplotData;
      this.polarplotlyData = polarplotData;
      this.boxplotlyLayout.yaxis.title =
        this.$t("details.graphs.thickness") + " (" + this.length1.view + ")";
      this.lineplotlyLayout.xaxis.title =
        this.$t("details.graphs.distance") + " (" + this.length1.view + ")";
      this.lineplotlyLayout.yaxis.title =
        this.$t("details.graphs.thickness") + " (" + this.length1.view + ")";
    },
    /**
     * watcher to handle change in selected measurement
     * @param {obj} val - the selected inspection
     */
    selectedMeasurement: function(val) {
      this.calculate_local_spots(val);
    },
    /**
     * watcher to handle change in minimum width spot parameter
     */
    localSpotsWidthMin: function() {
      this.calculate_local_spots(this.selectedMeasurement);
    },
    /**
     * watcher to handle change in minimum depth spot parameter
     */
    localSpotsRelativeDepth: function() {
      this.calculate_local_spots(this.selectedMeasurement);
    },
  },
  mounted() {
    //console.log(this.details_page.selected_inspections);
    if (!this.groupServices.includes("pipescanner-inspections")) {
      this.$router.push("/");
    } else {
      this.get_inspection_data();
    }
  },
  methods: {
    /**
     * mapped function
     */
    convert: convert,
    /**
     * function to fetch images for inspection from api
     */
    async get_images() {
      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var endpoint =
        this.apiEndpoints.base +
        this.apiEndpoints.pipescanner.images +
        this.selectedInspection.id +
        "/" +
        this.groupSelected;

      axios
        .get(endpoint, header)
        .then((response) => {
          this.images = response.data.map((x) => {
            return { id: x.fileName, src: x.image };
          });
          this.imagesLoading = false;
        })
        .catch((error) => {
          if (error) {
            this.$notify({
              message: error,
              icon: "check",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger",
            });
          }
        });
    },
    /**
     * calculates local spots and prepares the plotting data
     * @param {string} val - selected measurement
     */
    calculate_local_spots(val) {
      if (this.selectedInspection.material == "AC") {
        var sRaw = this.selectedInspection.results[val].dist;
        var wtRaw = this.selectedInspection.results[val].wt_remaining;
        //var wtRaw = this.lineplotlyData[val][0].y;
        //var sRaw = this.lineplotlyData[val][0].x;

        var sortingArray = [];
        for (var j = 0; j < sRaw.length; j++) {
          sortingArray.push({ s: sRaw[j], wt: wtRaw[j] });
        }

        sortingArray.sort((a, b) => {
          return a.s - b.s;
        });

        console.log(sortingArray);

        var s = sortingArray.map((x) => x.s);
        var wt = sortingArray.map((x) => x.wt);
        var wtOrg = this.lineplotlyData[val][1].y[0];
        var offset = convert(2)
          .from(this.length1.save)
          .to(this.length1.view);
        this.lineplotlyLayout.yaxis["range"] = [0, wtOrg + offset];
        var localSpots = new LocalDegradationSpots(
          s,
          wt,
          this.selectedInspection.wallthickness_expected_validation
        );
        //console.log(test.filter_spots(0.1, 0.5, 10.0))
        var spots = localSpots.filter_spots(
          parseFloat(this.localSpotsRelativeDepth) / 100.0,
          1.0,
          parseFloat(this.localSpotsWidthMin)
        ).filteredSpots;
        //console.log(spots);
        var lines = spots.map((i) => {
          return [
            {
              x: [
                convert(i.distanceStart)
                  .from(this.length1.save)
                  .to(this.length1.view),
                convert(i.distanceStart)
                  .from(this.length1.save)
                  .to(this.length1.view),
              ],
              y: [0, wtOrg + offset],
              fill: "tozeroy",
              type: "scatter",
              mode: "none",
              fillcolor: "rgba(214, 39, 40, 0.2)",
              line: {
                color: "rgba(214, 39, 40, 0.2)",
              },
              opacity: 0.5,
              fillopacity: 0.5,
              showlegend: false,
            },
            {
              x: [
                convert(i.distanceStop)
                  .from(this.length1.save)
                  .to(this.length1.view),
                convert(i.distanceStop)
                  .from(this.length1.save)
                  .to(this.length1.view),
              ],
              y: [0, wtOrg + offset],
              fill: "tonexty",
              type: "scatter",
              fillcolor: "rgba(214, 39, 40, 0.2)",
              line: {
                color: "rgba(214, 39, 40, 0.2)",
              },
              opacity: 0.5,
              fillopacity: 0.5,
              mode: "none",
              showlegend: false,
            },
          ];
        });
        this.tableSpots = spots;
        this.localSpots = lines.flat();
      }
    },
    /**
     * function to grab inspection details of the selected inspection.
     * @param {String} id - uuid of selected inspection
     */
    change_selected_inspection(id) {
      this.selectedInspection = this.inspectionData.filter((x) => {
        if (x.id == id) {
          return true;
        } else {
          return false;
        }
      })[0];
      this.menuVisible = false;
    },
    /**
     * function to fetch inspection data of selected inspections from the api
     */
    async get_inspection_data() {
      this.dataLoading = true;
      var query = {
        query:
          "SELECT * FROM c WHERE c.id IN (" +
          this.details_page.selected_inspections
            .map((x) => '"' + x.id + '"')
            .join() +
          ")",
      };
      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var endpoint =
        this.apiEndpoints.base + this.apiEndpoints.pipescanner.custom;

      axios
        .post(endpoint, query, header)
        .then((response) => {
          console.log(response.data);
          this.inspectionData =
            response.data[this.groupSelected + "-pipescanner-inspections"];
          this.selectedInspection = this.inspectionData[0];
          this.dataLoading = false;
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
  },
};
</script>
